import { Button, Dialog } from 'Components/Core';

interface IConfirmBulkAddRowsDialog {
  visible: boolean;
  rowsToAdd: number;
  onCancel: () => any;
  onConfirm: () => any;
}

const ConfirmBulkAddRowsDialog: React.FC<IConfirmBulkAddRowsDialog> = ({ visible, rowsToAdd, onConfirm, onCancel }) => {
  return (
    <Dialog
      buttons={[
        <Button key="addRowsButton" onClick={onConfirm} primary>
          Add
        </Button>,
        <Button key="cancelAddingRows" onClick={onCancel}>
          Cancel
        </Button>,
      ]}
      title="Add Rows"
      visible={visible}
      onClose={onCancel}
    >
      {`A large number of rows, ${rowsToAdd}, will be added. Are you sure you want to continue?`}
    </Dialog>
  );
};

export { ConfirmBulkAddRowsDialog };
